import { Capacitor } from '@capacitor/core'

/**
 * True only inside the Capacitor store binary (iOS/Android shell). The web build — and every
 * vitest run, which mocks `@capacitor/core` to `isNativePlatform: () => false` — takes the
 * unchanged cookie path everywhere this is consulted.
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform()
}
